"use client";
import React, { PropsWithChildren } from "react";
import { usePathname } from "next/navigation";
import ClientLayout from "./ClientLayout";
import { Provider } from "react-redux";
import { store } from "@/lib/store/store";
import StoryLayout from "./StoryLayout";
import { StoryProvider } from "@/contexts/StoryContext";
import AuthLayout from "./AuthLayout";
import IntlProviderMain from "../../IntlProviderMain";
import { SearchProvider } from "@/contexts/SearchContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { ApolloWrapper } from "@/app/ApolloWrapper";
import { ToastContainer } from "react-toastify";
import AlertHandler from "@/components/common/AlertHandler/AlertHandler";
import { QuoteProvider } from "@/contexts/QuoteContext";
import { ProfileProvider } from "@/contexts/ProfileContext";

const MainLayout = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  const isAuthRoute = pathname.includes("/auth");
  const pathOnStories = pathname.startsWith("/stories");

  return isAuthRoute && !pathOnStories ? (
    <Provider store={store}>
      <IntlProviderMain>
        <AuthProvider>
          <ApolloWrapper>
            <AlertHandler />
            <ToastContainer />
            <AuthLayout>{children}</AuthLayout>
          </ApolloWrapper>
        </AuthProvider>
      </IntlProviderMain>
    </Provider>
  ) : !isAuthRoute && pathOnStories ? (
    <Provider store={store}>
      <IntlProviderMain>
        <AuthProvider>
          <ApolloWrapper>
            <StoryProvider>
              <AlertHandler />
              <ToastContainer />
              <StoryLayout>{children}</StoryLayout>
            </StoryProvider>
          </ApolloWrapper>
        </AuthProvider>
      </IntlProviderMain>
    </Provider>
  ) : (
    <Provider store={store}>
      <IntlProviderMain>
        <AuthProvider>
          <QuoteProvider>
            <ApolloWrapper>
              <ProfileProvider>
                <SearchProvider>
                  <StoryProvider>
                    <AlertHandler />
                    <ToastContainer />
                    <ClientLayout>{children}</ClientLayout>
                  </StoryProvider>
                </SearchProvider>
              </ProfileProvider>
            </ApolloWrapper>
          </QuoteProvider>
        </AuthProvider>
      </IntlProviderMain>
    </Provider>
  );
};

export default MainLayout;
